import { Injectable } from '@angular/core';
import { CommonService } from '@core/services/common/common.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { LoadStatesProperties, LoadStatesProps } from './states.actions';
import { defaultCountryCode } from '@core/constants';
import { CountryState } from '@core/models/country-list-response';

@Injectable()
export class StatesEffects {
  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private commonService: CommonService
  ) {}

  loadStates$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(LoadStatesProps),
        exhaustMap(() => {
          return this.commonService.getStatesByCountry(defaultCountryCode).pipe(
            map((res) => {
              const states: CountryState[] = Array.isArray(res.data)
                ? res.data
                : [];

              this.store.dispatch(
                LoadStatesProperties({
                  statesProperties: states,
                })
              );
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
